module.exports = __webpack_public_path__ + "img/kyivstar-logo.cd0884f2.png";